import { Component, OnInit } from '@angular/core';
import { NzI18nService } from 'ng-zorro-antd/i18n';
import { getISOWeek } from 'date-fns';
import { JudgementService } from '../../core/services/judgement.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-users',
  templateUrl: './judgments.component.html',
  styleUrls: ['./judgments.component.scss'],
})
export class JudgmentsComponent implements OnInit {
  breadcrumbs = [
    {
      title: 'Judgments',
    },
  ];

  date: any;
  data: any[] = [];
  tempData: any[] = [];
  totalDocs = 0;
  currentPage = 1;
  pageSize = 4;
  searchValue = '';
  selectedCourt = '';

  constructor( private judgementService: JudgementService, private datePipe: DatePipe,
  ) {}

  ngOnInit(): void {
    this.loadCourt();
  }

  loadCourt(): void {
    this.judgementService
      .getJudgements(this.currentPage, this.pageSize)
      .then((response) => {
        this.data = response.docs;
        this.tempData = response.docs;
  
        this.totalDocs = response.totalDocs;
      });
  }

  getCaseBySearch(): void {
    this.judgementService
      .getJudgementBySearch(this.searchValue, this.currentPage, this.pageSize)
      .then((response) => {
        this.data = response.docs;
        this.totalDocs = response.totalDocs;
      });
  }

  getCasesByCourt(value: any): void {
    this.judgementService
      .getJudgementByCourt(value, this.currentPage, this.pageSize)
      .then((response) => {
        this.data = response.docs;
        this.totalDocs = response.totalDocs;
      });
  }

  cancelSearch(): any {
    this.searchValue = '';
    this.currentPage = 1;
    this.selectedCourt = '';
    this.date = null
    this.loadCourt();
  }

  formatDateTime(date: string): any {
    const originalDate = new Date(date);
    return this.datePipe.transform(originalDate, 'MMM d, y');
  }

  onCurrentPageDataChange(page: any): void {
    this.currentPage = page;
    this.loadCourt();
  }

  onChange(date: any): void {
    this.data = this.tempData;
    if (date === null) {
      this.loadCourt();
    } else {
      this.data = this.filterEventsByStartDate(this.data, date);
    }
  }

  filterEventsByStartDate(originalEvents: any[], dateToCompare: Date): any[] {
    return originalEvents.filter((event) => {
      const date = new Date(event.date);
      return (
        date.getFullYear() === dateToCompare.getFullYear() &&
        date.getMonth() === dateToCompare.getMonth() &&
        date.getDate() === dateToCompare.getDate()
      );
    });
  }

  getWeek(result: Date): void {
    console.log('week: ', getISOWeek(result));
  }
}
